import { appendAPExamTemplate } from '@/functions/idp'

import RIC from './RIC_6'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
